
export function SecuritySection() {
  const certifications = [
    { name: 'ISO 27001', description: 'Information Security Management' },
    { name: 'GDPR Compliant', description: 'Data Protection Regulation' },
    { name: 'Cyber Essentials Plus', description: 'UK Government Certification' },
    { name: 'SOC 2 Type II', description: 'Security & Availability' }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Enterprise-Grade Security You Can Trust
            </h2>
            <p className="text-xl text-gray-400">
              Your data security is our top priority
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <h3 className="text-2xl font-semibold text-white mb-6">
                Built with Security by Design
              </h3>
              <div className="space-y-6">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-lock-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-2">End-to-End Encryption</h4>
                    <p className="text-gray-400">All data is encrypted in transit and at rest using AES-256 encryption standards.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-server-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-2">UK Data Centers</h4>
                    <p className="text-gray-400">Your data never leaves the UK, ensuring compliance with local regulations.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-eye-off-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-2">Zero-Knowledge Architecture</h4>
                    <p className="text-gray-400">We can't access your business data - only threat patterns are analyzed.</p>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center mr-4 mt-1">
                    <i className="ri-shield-check-line text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-white mb-2">Regular Security Audits</h4>
                    <p className="text-gray-400">Independent third-party security assessments ensure continuous protection.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <img
                src="https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&h=500&fit=crop&crop=center"
                alt="Secure data infrastructure"
                className="w-full h-auto rounded-xl shadow-lg object-cover"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {certifications.map((cert, index) => (
              <div key={index} className="bg-gray-800/50 p-6 rounded-xl text-center border border-gray-700">
                <div className="w-12 h-12 bg-blue-500/200/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-award-line text-blue-400 text-xl"></i>
                </div>
                <h4 className="font-semibold text-white mb-2">
                  {cert.name}
                </h4>
                <p className="text-gray-400 text-sm">
                  {cert.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
